import {Divider, Stack, Typography} from '@mui/material';
import React, {Fragment} from 'react';

import {Drawer} from 'presentation/components/Drawer';
import {Filter} from 'presentation/components/Filter';
import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';

import {useAppointmentsHistoryFilter} from './hooks/useAppointmentsHistoryFilter';
import {FilterHeaderProps} from './types';
import {CTAButtonFixed} from 'presentation/components';

const {filter: filterText} = translations['pt-br'].commons;
const {newAppointment} = translations['pt-br'].privateFlow.myAppointments;
const {history} = translations['pt-br'].privateFlow.requestAuthorizations.tabs;

export function AppointmentsHistoryFilterHeader({
	handleNewAppointment,
	totalCount,
}: FilterHeaderProps) {
	const {
		hasFilters,
		openDrawerState,
		listFilters,
		handleOpenDrawer,
		handleCloseDrawer,
		handleApplyFilter,
		handleClearFilter,
		appointmentFindResults,
		shouldHideComponent,
		isValid,
		theme,
		isMobile,
		bookingType,
		shouldShowAppointmentButton,
	} = useAppointmentsHistoryFilter(totalCount);

	if (shouldHideComponent) return null;

	return (
		<Stack marginBottom={2} gap={2}>
			{isValid ? null : (
				<Typography fontWeight={700} sx={{color: theme.colors.light.text.secondary}}>
					{history}
				</Typography>
			)}
			<Stack direction="row" justifyContent={'space-between'} alignItems={'center'}>
				<Typography fontSize={'1rem'} sx={{color: theme.colors.light.text.secondary}}>
					<Typography fontWeight={700} component={'span'}>
						{totalCount}
					</Typography>
					{appointmentFindResults}
				</Typography>

				<Stack direction={'row'} alignItems={'center'} gap={1}>
					{hasFilters ? (
						<Fragment>
							<Filter.Button
								onClick={handleOpenDrawer}
								count={bookingType ? 1 : undefined}>
								{filterText}
							</Filter.Button>
							<Drawer.Root
								open={openDrawerState}
								onOpen={handleOpenDrawer}
								onClose={handleCloseDrawer}
								width={'600px'}>
								<Drawer.Header title="Filtros" onClose={handleCloseDrawer} />
								<Drawer.ContentListByCategory categoryList={listFilters} />
								<Drawer.Footer
									firstButtonOnClick={handleClearFilter}
									secondButtonOnClick={handleApplyFilter}
								/>
							</Drawer.Root>
							{isMobile || !shouldShowAppointmentButton ? null : (
								<Divider orientation="vertical" sx={{width: 2, height: 30}} />
							)}
						</Fragment>
					) : null}

					{shouldShowAppointmentButton ? (
						<CTAButtonFixed.Root>
							<CTAButtonFixed.Action
								fullWidth
								size={isMobile ? 'large' : 'medium'}
								variant="contained"
								endIcon={<Icon name="event-filled" />}
								onClick={handleNewAppointment}>
								{newAppointment}
							</CTAButtonFixed.Action>
						</CTAButtonFixed.Root>
					) : null}
				</Stack>
			</Stack>
		</Stack>
	);
}
